import { gql } from "@apollo/client";

export const DELETE_AVAILABILITIES = gql`
  mutation deleteAvailabilities(
    $ids: [ID!],
  ) {
    deleteAvailabilities(
      ids: $ids
    ) {
      id
    }
  }
`;

export const DELETE_AVAILABILITY = gql`
  mutation deleteAvailability(
    $id: Int!,
  ) {
    deleteAvailability(
      id: $id
    )
  }
`;

export const ADD_AVAILABILITY = gql`
  mutation addAvailability(
    $id: Int!,
    $day: Days!,
    $from: String!,
    $to: String!
  ) {
    addAvailability(
      professionist_id: $id,
      day: $day,
      time_from: $from,
      time_to: $to
  ) {
      id
    }
  }
`;
